import BannerDialog from './banner';

export default () => <BannerDialog />;
